import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { EMAIL_REGEX } from '@core/enums/patterns';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  loginForm!: FormGroup | any;
  hidden = true;
  loginFailed = false;
  showPassword = false;
  private subscriptions = new Subscription();

  get email() {
    return this.loginForm.get('email');
  }
  get password() {
    return this.loginForm.get('password');
  }

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.initializeForms();
    if (this.authService.isLoggedIn()) this.router.navigateByUrl('/admin');
  }

  initializeForms(): void {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(EMAIL_REGEX)]],
      password: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^\S*$/),
        ],
      ],
    });
  }

  login(): void {
    this.loginFailed = false;
    this.authService
      .login(this.loginForm.value)
      .pipe(
        tap((res) => {
          this.loginFailed = !res ? true : false;
        })
      )
      .subscribe((res) => {
        if (res) {
          this.toastr.success('Login successful');
        }
      });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
